import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const policies = [{
  title: "1. Titolare del Trattamento",
  content: "Dolcisapori, con sede nel cuore della Sicilia, è il Titolare del Trattamento dei dati personali raccolti. Ci impegniamo a proteggere la tua privacy con la stessa cura e dedizione che riserviamo alla preparazione dei nostri dolci artigianali, nel pieno rispetto delle normative vigenti."
}, {
  title: "2. Tipologia di Dati Raccolti",
  content: "Raccogliamo esclusivamente le informazioni essenziali per offrirti un servizio d'eccellenza, come nome, indirizzo email e numero di telefono. Questi dati ci vengono forniti volontariamente quando richiedi informazioni sul nostro catalogo o effettui una prenotazione per le tue occasioni speciali."
}, {
  title: "3. Finalità del Trattamento",
  content: "I tuoi dati vengono utilizzati esclusivamente per gestire i tuoi ordini, rispondere alle tue richieste di personalizzazione e, solo previo tuo esplicito consenso, per inviarti aggiornamenti sulle nostre creazioni stagionali e sui segreti della nostra tradizione dolciaria."
}, {
  title: "4. Sicurezza e Riservatezza",
  content: "Il trattamento dei dati avviene attraverso sistemi informatici sicuri, adottando misure tecniche organizzative volte a prevenire perdite, usi illeciti o accessi non autorizzati. La tua fiducia è l'ingrediente più prezioso del nostro lavoro e la tuteliamo con il massimo rigore."
}, {
  title: "5. I Tuoi Diritti",
  content: "In conformità con il GDPR, hai il diritto di accedere ai tuoi dati, richiederne la rettifica, la portabilità o la cancellazione definitiva dai nostri archivi. Per esercitare questi diritti o per qualsiasi chiarimento, puoi contattarci direttamente attraverso i canali indicati nella sezione contatti."
}];
export default function PrivacyPolicy() {
  return <section data-section-id="227651" id="introduzione-alla-privacy" className="bg-background relative overflow-hidden py-20 md:py-32">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566661/img/celestial_map_texture.png)] opacity-0 bg-cover bg-center pointer-events-none" />

      <div className="max-w-[800px] mx-auto px-6 relative z-10 flex flex-col gap-12">
        <div className="text-left space-y-6">
          <h1 className="font-default text-primary text-4xl md:text-5xl font-bold tracking-tight">
            Informativa sulla Privacy
          </h1>
          <p className="font-sans text-foreground/90 text-lg md:text-xl max-w-2xl leading-[1.6]">
            In Dolcisapori, la trasparenza è un valore fondamentale. Questa informativa descrive come custodiamo i tuoi dati personali, garantendo un'esperienza sicura e autentica come i nostri prodotti.
          </p>
        </div>

        <div className="flex flex-col gap-8">
          {policies.map((policy, i) => <Card key={i} data-index={i} className="bg-card/30 backdrop-blur-none border-none shadow-none rounded-none overflow-hidden">
              <CardHeader className="pb-4 px-0">
                <CardTitle className="font-default text-primary text-2xl md:text-3xl font-semibold">
                  {policy.title}
                </CardTitle>
                <Separator className="mt-4 bg-primary/30 h-[1px]" />
              </CardHeader>
              <CardContent className="pt-0 px-0">
                <p className="font-sans text-foreground/80 leading-[1.8] text-base md:text-lg">
                  {policy.content}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}